<template>
    <transition name="fade" mode="out-in">
        <div
            class="normal-container pointer-events-none fixed right-0 bottom-12 left-0 z-10 flex justify-end"
            v-if="showScrollButton">
            <button
                @click="scrollToTop"
                class="scroll-to-top-btn bg-dark-900 pointer-events-auto flex h-10 w-10 items-center justify-center rounded-full p-2 shadow-lg transition hover:bg-gray-800 lg:h-16 lg:w-16 lg:p-4">
                <ArrowUpIcon class="size-9 text-white" />
            </button>
        </div>
    </transition>
</template>

<script setup>
    const snippetsStore = useSnippetsStore();
    const snippets = snippetsStore.snippets;

    import { ArrowUpIcon } from '@heroicons/vue/24/outline';

    let showScrollButton = ref(false);

    const handleScroll = () => {
        showScrollButton.value = window.scrollY > 500;
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    onMounted(() => {
        window.addEventListener('scroll', handleScroll);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('scroll', handleScroll);
    });
</script>
